/**
 * Prix par 100 g / unité — recalcul à partir du prix wholesale affiché (WPD) ou data-wcp-price-cents (Liquid).
 */
(function () {
  'use strict';

  var VARIANT_REGEX = /((?:\d+(?:[.,]\d+)?\s*[xX×]\s*)+)?(\d+(?:[.,]\d+)?)\s*(kg|lb|lbs|oz|gr|g|lt|l|ml|pcs|pc|un|unit[eé]s?)\b/i;

  var UNIT_MAP = {
    kg: { baseUnit: 'G', factor: 1000, refValue: 100, type: 'mass' },
    lb: { baseUnit: 'G', factor: 453.592, refValue: 100, type: 'mass' },
    lbs: { baseUnit: 'G', factor: 453.592, refValue: 100, type: 'mass' },
    oz: { baseUnit: 'G', factor: 28.35, refValue: 100, type: 'mass' },
    gr: { baseUnit: 'G', factor: 1, refValue: 100, type: 'mass' },
    g: { baseUnit: 'G', factor: 1, refValue: 100, type: 'mass' },
    l: { baseUnit: 'ML', factor: 1000, refValue: 100, type: 'volume' },
    lt: { baseUnit: 'ML', factor: 1000, refValue: 100, type: 'volume' },
    ml: { baseUnit: 'ML', factor: 1, refValue: 100, type: 'volume' },
    un: { baseUnit: 'UN', factor: 1, refValue: 1, type: 'unit' },
    pcs: { baseUnit: 'UN', factor: 1, refValue: 1, type: 'unit' },
    pc: { baseUnit: 'UN', factor: 1, refValue: 1, type: 'unit' },
    unit: { baseUnit: 'UN', factor: 1, refValue: 1, type: 'unit' },
    'unité': { baseUnit: 'UN', factor: 1, refValue: 1, type: 'unit' },
    'unités': { baseUnit: 'UN', factor: 1, refValue: 1, type: 'unit' }
  };

  function parseVariantFromTitle(title) {
    if (!title) return null;
    var match = String(title).match(VARIANT_REGEX);
    if (!match && /unit[eé]s?\b/i.test(title)) {
      return { multiplier: 1, rawQty: 1, rawUnit: 'un' };
    }
    if (!match) return null;

    var multiplierStr = match[1] || '';
    var multiplier = multiplierStr
      ? multiplierStr.split(/[xX×]/g).filter(function (s) { return s.trim(); })
        .map(function (s) { return parseFloat(s.replace(',', '.').trim()) || 1; })
        .reduce(function (a, b) { return a * b; }, 1)
      : 1;

    return {
      multiplier: multiplier,
      rawQty: parseFloat(match[2].replace(',', '.')),
      rawUnit: match[3].toLowerCase()
    };
  }

  function calcUnitPriceLabel(title, priceDollars) {
    if (priceDollars == null || isNaN(priceDollars) || priceDollars <= 0) return null;
    var parsed = parseVariantFromTitle(title);
    if (!parsed) return null;

    var unitInfo = UNIT_MAP[parsed.rawUnit];
    if (!unitInfo) return null;

    var totalBaseQty = parsed.rawQty * unitInfo.factor * parsed.multiplier;
    if (!totalBaseQty) return null;

    var pricePerRef = priceDollars / totalBaseQty * unitInfo.refValue;
    return unitInfo.type === 'unit'
      ? pricePerRef.toFixed(2) + ' $/UN'
      : pricePerRef.toFixed(2) + ' $/100' + unitInfo.baseUnit;
  }

  function parseMoneyText(text) {
    if (!text) return null;
    var s = String(text).replace(/[^\d.,]/g, '').trim();
    if (!s) return null;
    if (s.indexOf(',') > -1 && (s.indexOf('.') === -1 || s.lastIndexOf(',') > s.lastIndexOf('.'))) {
      s = s.replace(/\./g, '').replace(',', '.');
    } else {
      s = s.replace(/,/g, '');
    }
    var n = parseFloat(s);
    return isNaN(n) ? null : n;
  }

  function centsToDollars(cents) {
    var c = parseInt(cents, 10);
    return isNaN(c) ? null : c / 100;
  }

  function getWcpCentsFromContext(ctx) {
    if (!ctx) return null;
    var sel = ctx.querySelector && ctx.querySelector('.dg-variant-select');
    if (sel && sel.selectedIndex >= 0) {
      var opt = sel.options[sel.selectedIndex];
      if (opt && opt.dataset.wcpPriceCents) return centsToDollars(opt.dataset.wcpPriceCents);
    }
    if (ctx.dataset && ctx.dataset.wcpPriceCents) return centsToDollars(ctx.dataset.wcpPriceCents);
    return null;
  }

  function getActivePriceEl(container) {
    if (!container) return null;
    var sale = container.querySelector('.dg-price--sale');
    if (sale && sale.offsetParent !== null) return sale;
    var main = container.querySelector('.pdp-price__main');
    if (main) return main;
    var qv = container.querySelector('#dg-qv-price');
    if (qv) return qv;
    return container.querySelector('.dg-price');
  }

  function getDisplayedPriceDollars(priceEl, ctx) {
    var wcp = getWcpCentsFromContext(ctx);
    if (wcp != null) return wcp;

    if (!priceEl) return null;

    var parsed = parseMoneyText(priceEl.textContent);
    if (parsed != null) return parsed;

    var cents = priceEl.getAttribute('data-wpd-variant-price');
    if (cents !== null && cents !== '') return centsToDollars(cents);

    return null;
  }

  function getVariantTitle(ctx) {
    if (!ctx) return null;
    if (ctx.dataset && ctx.dataset.variantTitle) return ctx.dataset.variantTitle;
    var sel = ctx.querySelector && ctx.querySelector('.dg-variant-select');
    if (sel && sel.selectedIndex >= 0) {
      var opt = sel.options[sel.selectedIndex];
      if (opt.dataset.variantTitle) return opt.dataset.variantTitle;
      return opt.textContent.replace(/\s*—\s*Épuisé\s*$/i, '').trim();
    }
    var badge = ctx.querySelector && ctx.querySelector('.dg-product-card__format-badge');
    if (badge) return badge.textContent.trim();
    return null;
  }

  function applyUnitLabel(unitEl, title, priceDollars) {
    if (!unitEl || !title) return;
    var label = calcUnitPriceLabel(title, priceDollars);
    if (label) {
      unitEl.textContent = label;
      unitEl.style.display = '';
    }
  }

  function refreshProductCard(card) {
    if (!card) return;
    var unitEl = card.querySelector('[data-unit-price], .dg-unit-price');
    if (!unitEl) return;
    var priceBlock = card.querySelector('.dg-product-card__price');
    var title = getVariantTitle(card) || getVariantTitle(unitEl);
    var price = getDisplayedPriceDollars(getActivePriceEl(priceBlock), card);
    if (!title || price == null) return;
    applyUnitLabel(unitEl, title, price);
  }

  function refreshPdpUnitPrice() {
    var unitEl = document.getElementById('pdp-unit-price');
    if (!unitEl) return;
    var priceBlock = document.querySelector('.pdp-price-block');
    var active = document.querySelector('.pdp-variant-card.is-active');
    var title = (active && (active.dataset.variantTitle || (active.querySelector('.pdp-variant-card__name') && active.querySelector('.pdp-variant-card__name').textContent.trim())))
      || unitEl.dataset.variantTitle;
    var ctx = active || unitEl;
    var price = getDisplayedPriceDollars(document.querySelector('.pdp-price__main'), ctx);
    if (!title || price == null) return;
    applyUnitLabel(unitEl, title, price);
  }

  function refreshQuickViewUnitPrice() {
    var bodyEl = document.getElementById('dg-qv-body');
    if (!bodyEl) return;
    var unitEl = bodyEl.querySelector('#dg-qv-unit-price');
    if (!unitEl) return;
    var priceBlock = bodyEl.querySelector('.dg-qv-price-block') || bodyEl;
    var title = getVariantTitle(bodyEl);
    var price = getDisplayedPriceDollars(bodyEl.querySelector('#dg-qv-price'), bodyEl);
    if (!title || price == null) return;
    applyUnitLabel(unitEl, title, price);
  }

  function refreshAllUnitPrices(root) {
    root = root || document;
    root.querySelectorAll('.dg-product-card').forEach(refreshProductCard);
    if (root === document || root.querySelector('.pdp-price-block') || root.querySelector('#pdp-unit-price')) {
      refreshPdpUnitPrice();
    }
    if (root === document || root.querySelector('#dg-qv-body')) {
      refreshQuickViewUnitPrice();
    }
  }

  window.dgCalcUnitPriceLabel = calcUnitPriceLabel;
  window.dgRefreshProductCard = refreshProductCard;
  window.dgRefreshPdpUnitPrice = refreshPdpUnitPrice;
  window.dgRefreshQuickViewUnitPrice = refreshQuickViewUnitPrice;
  window.dgRefreshAllUnitPrices = refreshAllUnitPrices;

  var debounceTimer;
  function scheduleRefresh() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () { refreshAllUnitPrices(); }, 50);
  }

  function startWpdPolling() {
    var attempts = 0;
    var maxAttempts = 24;
    var interval = setInterval(function () {
      refreshAllUnitPrices();
      attempts += 1;
      if (attempts >= maxAttempts) clearInterval(interval);
    }, 500);
  }

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      var t = m.target;
      if (t.nodeType === 3) t = t.parentElement;
      if (!t || !t.closest) continue;
      if (t.closest('.dg-product-card, .pdp-price-block, #dg-qv-body, .dg-product-card__price')) {
        scheduleRefresh();
        return;
      }
    }
  });

  function init() {
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['class', 'data-wpd-variant-price', 'data-wcp-price-cents']
    });
    scheduleRefresh();
    startWpdPolling();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    scheduleRefresh();
    startWpdPolling();
  });
})();
